import * as yup from "yup";

import {
  _11_20_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98967,
  _21_30_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98968,
  _30_MIN_INDIVIDUAL_90832,
  _45_MIN_INDIVIDUAL_90834,
  _5_10_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98966,
  _60_MIN_INDIVIDUAL_90837,
  CM_SERVICES_20_MINS_MINIMUM_MONTH,
  CRISIS_EVAL_90839,
  CRISIS_EVAL_EXTENDED_90840,
  ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
  FAMILY_THERAPY_90847,
  FAMILY_THERAPY_WO_PATIENT_90846,
  hourArray,
  MEDICATION_MGMT_99212,
  MEDICATION_MGMT_99213,
  MEDICATION_MGMT_99214,
  minuteArray,
  OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
  OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
} from "@/components/Provider/ScheduleAvailability/constants";
import { makeCnaiProps } from "@/lib/helpers/clinically-ai";
import { MaxDateValidation } from "@/component-library/validation";
import { ProviderEnum } from "@/core/constants";

const BEHAVIORAL = ProviderEnum.BEHAVIORAL;
const BEHAVIORAL_INTAKE = ProviderEnum.BEHAVIORAL_INTAKE;
const PRESCRIBE = ProviderEnum.PRESCRIBE;

export const CARE_COMMUNICATION_INITIAL_VALUES = {
  call_type: "",
  communication_type: "",
  content: {
    communication_and_plan: "",
    communication_type: "",
    encounters: [],
    reason_for_communication: [],
    reason_for_communication_other: "",
  },
  ICD_10_axis_1_diagnosis: [],
  ICD_10_axis_2_diagnosis: [],
  is_billable: false,
  is_processed: false,
  note_type: "Care Communication",
  patient_first_name: "",
  patient_id: "",
  patient_last_name: "",
  provider_cp_credentials: "",
  provider_id: "",
  provider_name: "",
  provider_type: "",
  session_date: "",
  session_from_am_pm: "",
  session_from_hr: "",
  session_from_min: "",
  signature: "",
  title: "Care Communication Note",
  version: 5,
};

export const CARE_COMMUNICATION_VALIDATION = yup.object().shape({
  call_type: yup.string().required("Required"),
  content: yup.object().shape({
    communication_and_plan: yup.string().required("Required"),
    communication_type: yup.string().required("Required"),
    encounters: yup.array().of(
      yup.object().shape({
        encounter_date: yup.string().required("Required").nullable(),
        encounter_type: yup.string().required("Required").nullable(),
        setting: yup.string().required("Required").nullable(),
      }),
    ),
    reason_for_communication: yup.string().required("Required"),
  }),
  ICD_10_axis_1_diagnosis: yup
    .string()
    .test("non-billable", "Required", function (value) {
      const callType = this.parent.call_type;

      if (callType === "non_billable") {
        return true;
      } else if (!value) {
        return false;
      } else {
        return true;
      }
    })
    .nullable(),
  provider_cp_credentials: yup.string().required("Required"),
  session_date: MaxDateValidation,
  session_from_am_pm: yup.string().required("Required"),
  session_from_hr: yup.string().required("Required"),
  session_from_min: yup.string().required("Required"),
  signature: yup.string().required("Required"),
});

export const CARE_COMMUNICATION_SCHEMA = [
  {
    elementClasses: "col-12 col-lg-3",
    elementConfig: {
      label: "Communication Type",
      options: [
        { display: "Call", value: "Call" },
        { display: "Text", value: "Text" },
        { display: "Email", value: "Email" },
        { display: "apti Messaging", value: "apti Messaging" },
        { display: "On Call", value: "On Call" },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    inputClasses: "Input--sm-dropdown",
    name: "content.communication_type",
    testLocatorId: "communicationTypeSelect",
  },
  {
    elementClasses: "col-12 col-lg-3 col-md-3",
    elementConfig: {
      label: "Date",
      placeholder: "01/01/2020",
      type: "text",
    },
    elementType: "datePicker",
    inputClasses: "Input--sm",
    name: "session_date",
  },
  {
    elementClasses: "col-12 col-lg-2 col-md-3",
    elementConfig: {
      label: "Hour",
      options: hourArray,
      placeholder: "",
      sentenceCase: false,
    },
    elementType: "select",
    inputClasses: "Input--sm-dropdown",
    name: "session_from_hr",
    testLocatorId: "sessionFromHr",
  },
  {
    elementClasses: "col-12 col-lg-2 col-md-3",
    elementConfig: {
      label: "Minute",
      options: minuteArray,
      placeholder: "",
      sentenceCase: false,
    },
    elementType: "select",
    inputClasses: "Input--sm-dropdown",
    name: "session_from_min",
    testLocatorId: "sessionFromMin",
  },
  {
    elementClasses: "col-12 col-lg-2 col-md-3",
    elementConfig: {
      label: "am/pm",
      options: [
        { display: "am", value: "am" },
        { display: "pm", value: "pm" },
      ],
      placeholder: "",
      sentenceCase: false,
    },
    elementType: "select",
    inputClasses: "Input--sm-dropdown",
    name: "session_from_am_pm",
    testLocatorId: "sessionFromAmPm",
  },
  {
    elementClasses: "col-lg-9 col-12",
    elementConfig: {
      label: "CPT Description",
      options: [
        {
          display: "90832: 30 Minutes Individual",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: _30_MIN_INDIVIDUAL_90832,
        },
        {
          display: "90834: 45 Minutes Individual",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: _45_MIN_INDIVIDUAL_90834,
        },
        {
          display: "90837: 60 Minutes Individual",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: _60_MIN_INDIVIDUAL_90837,
        },
        {
          display: "90839: 15 Minutes Crisis evaluation",
          provider_types: [PRESCRIBE],
          value: CRISIS_EVAL_90839,
        },
        {
          display: "90839: 45 Minutes Crisis evaluation",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: CRISIS_EVAL_90839,
        },
        {
          display: "90840: 75 Minutes Crisis Evaluation Extended",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: CRISIS_EVAL_EXTENDED_90840,
        },
        {
          display: "90847: 45 Minutes Family Therapy w/ Patient",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: FAMILY_THERAPY_90847,
        },
        {
          display: "90846: 45 Minutes Family Therapy w/o Patient",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: FAMILY_THERAPY_WO_PATIENT_90846,
        },
        {
          display: "98966: 5-10 Minutes Phone Assmt. And Mgmt.",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE, PRESCRIBE],
          value: _5_10_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98966,
        },
        {
          display: "98967: 11-20 Minutes Phone Assmt. And Mgmt",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE, PRESCRIBE],
          value: _11_20_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98967,
        },
        {
          display: "98968: 21-30 Minutes Phone Assmt. And Mgmt",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE, PRESCRIBE],
          value: _21_30_PHONE_ASSESSMENT_AND_MGMT_VS_MED_DISCUSSION_98968,
        },
        {
          display: "99204: 60 Minutes Office or Other Outpatient Visit w/ New Patient",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99204,
        },
        {
          display: "99205: 75 Minutes Office or Other Outpatient Visit w/ New Patient",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE],
          value: OFFICE_OR_OTHER_OUTPATIENT_VISIT_W_NEW_PATIENT_99205,
        },
        {
          display: "99212: 15 Minutes Medication Management",
          provider_types: [PRESCRIBE],
          value: MEDICATION_MGMT_99212,
        },
        {
          display: "99213: 15 Minutes Medication Management",
          provider_types: [PRESCRIBE],
          value: MEDICATION_MGMT_99213,
        },
        {
          display: "99214: 30 Minutes Medication Management",
          provider_types: [PRESCRIBE],
          value: MEDICATION_MGMT_99214,
        },
        {
          display: "99215: 45 Minutes Established Patient Complex",
          provider_types: [PRESCRIBE],
          value: ESTABLISHED_PATIENT_OFFICE_OR_OTHER_OUTPATIENT_SERVICES_99215,
        },
        {
          display: "99484: 20 Minutes CM Services, Min 20 Minutes Calendar Month",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE, PRESCRIBE],
          value: CM_SERVICES_20_MINS_MINIMUM_MONTH,
        },
        {
          display: "Non Billable",
          provider_types: [BEHAVIORAL, BEHAVIORAL_INTAKE, PRESCRIBE],
          value: "non_billable",
        },
      ],
      placeholder: "Select",
    },
    elementType: "select",
    inputClasses: "Input--sm-dropdown",
    name: "call_type",
    testLocatorId: "cptCodeSelect",
  },
  {
    elementClasses: "col-12",
    elementConfig: {
      label: "Reason for Communication",
      optionClasses: "col-lg-3 col-12 py-1",
      options: [
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Appointment Changes",
            type: "multiple_choice",
          }),
          display: "Appointment Changes",
          value: "Appointment Changes",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Medical",
            type: "multiple_choice",
          }),
          display: "Medical",
          value: "Medical",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Acute Care Encounter",
            type: "multiple_choice",
          }),
          display: "Acute Care Encounter",
          value: "Acute Care Encounter",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Medication",
            type: "multiple_choice",
          }),
          display: "Medication",
          value: "Medication",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "SUD",
            type: "multiple_choice",
          }),
          display: "SUD",
          value: "SUD",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "SDoH",
            type: "multiple_choice",
          }),
          display: "SDoH",
          value: "SDoH",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Outreach/Support",
            type: "multiple_choice",
          }),
          display: "Outreach/Support",
          value: "Outreach/Support",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Care Team Collaboration",
            type: "multiple_choice",
          }),
          display: "Care Team Collaboration",
          value: "Care Team Collaboration",
        },
        {
          cnaiProps: makeCnaiProps({
            id: "reason-for-communication",
            name: "Reason for Communication",
            option: "Other",
            type: "multiple_choice",
          }),
          display: "Other (open text)",
          openText: true,
          openTextCnaiProps: makeCnaiProps({
            id: "reason-for-communication-other",
            name: "Reason for Communication (Other)",
            type: "string",
          }),
          value: "Other (open text)",
        },
      ],
      type: "checkbox",
    },
    elementType: "input",
    errorClasses: "InputError--lg-2",
    name: "content.reason_for_communication",
    testLocatorId: "reasonForCommunication",
  },
  {
    elementType: "encounters",
    name: "content.encounters",
  },
  {
    cnaiProps: makeCnaiProps({
      id: "communication-and-plan",
      name: "Communication & Plan",
      type: "string",
    }),
    elementClasses: "col-11",
    elementConfig: {
      label: "Communication & Plan",
      placeholder: "Type Comment...",
      showNewLineTip: true,
      type: "textArea",
    },
    elementType: "textarea",
    errorClasses: "InputError--lg-2",
    inputClasses: "Input--lg",
    name: "content.communication_and_plan",
    testLocatorId: "communicationPlanTextarea",
  },
  {
    elementClasses: "col-12 col-lg-6",
    elementConfig: {
      label: "Primary Diagnosis (Provisional Diagnosis)",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_axis_1_diagnosis",
  },
  {
    elementClasses: "col-12 col-lg-6",
    elementConfig: {
      label: "Secondary Diagnosis (Provisional Diagnosis)",
      options: [],
      placeholder: "",
    },
    elementType: "reactselect",
    name: "ICD_10_axis_2_diagnosis",
  },
  {
    elementClasses: "col-12 col-lg-7",
    elementConfig: {
      classNames: "font-weight-bold",
      displayName: "Click to Sign",
      hideTopLabel: true,
      label: "Signature",
      type: "checkbox",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: "signature",
    testLocatorId: "clickToSignCheckbox",
  },
  {
    disabled: "disabled",
    elementClasses: "col-12 col-lg-3",
    elementConfig: {
      label: "Credentials",
      placeholder: "",
      type: "text",
    },
    elementType: "input",
    inputClasses: "Input--sm",
    name: "provider_cp_credentials",
  },
];
